import { render, staticRenderFns } from "./binding-form.vue?vue&type=template&id=1784c708&"
import script from "./binding-form.vue?vue&type=script&lang=js&"
export * from "./binding-form.vue?vue&type=script&lang=js&"
import style0 from "./binding-form.vue?vue&type=style&index=0&id=1784c708&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports